(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-calculate-shipping"] && !Shopify.designMode) return;
  try {
    function addBusinessDays(startDate, days) {
    var result = new Date(startDate);
    var added = 0;
    while (added < days) {
        result.setDate(result.getDate() + 1);
        var day = result.getDay();
        if (day !== 0 && day !== 6) {
            added++;
        }
    }
    return result;
}

function formatDeliveryDate(date) {
    return new Intl.DateTimeFormat('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
}

function getDeliveryEstimate(deliveryDays) {
    var today = new Date();
    var shipDate = addBusinessDays(today, 1);
    var minDate = addBusinessDays(shipDate, deliveryDays[0]);
    var maxDate = addBusinessDays(shipDate, deliveryDays[1]);

    if (deliveryDays[0] === deliveryDays[1]) {
        return formatDeliveryDate(minDate);
    }

    return formatDeliveryDate(minDate) + ' – ' + formatDeliveryDate(maxDate);
}

document.addEventListener('DOMContentLoaded', function() {
    var shippingCalculator = document.getElementById('shipping_calculator');
    var productId = Number(shippingCalculator.dataset.productId);
    var productPrice = Number(shippingCalculator.dataset.productPrice);
    var itemKey = '';

    document.getElementById('calculate_shipping').addEventListener('click', function() {
        var zipCode = document.getElementById('zip_code').value;
        var shippingResult = document.getElementById('shipping_result');

        zipCode = zipCode.replace(/\D/g, '');

        if (zipCode.length === 8) {
            zipCode = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
        } else {
            shippingResult.innerHTML = "CEP inválido. Certifique-se de inserir 8 dígitos.";
            return;
        }

        var province = '';

        fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`)
            .then(response => response.json())
            .then(data => {
                if (data.uf) {
                    province = data.uf;
                } else {
                    throw new Error("Não foi possível determinar o estado para o CEP fornecido.");
                }
                return fetch('/cart.js');
            })
            .then(cartResponse => cartResponse.json())
            .then(cart => {
                if (cart.items.length > 0) {
                    return fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=BR&shipping_address[province]=${province}`);
                } else {
                    return fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: productId, quantity: 1 })
                    })
                    .then(addResponse => addResponse.json())
                    .then(() => fetch(`/cart.js`))
                    .then(cartResponse => cartResponse.json())
                    .then(cart => {
                        if (cart.items.length === 0) {
                            throw new Error("Carrinho vazio após adicionar produto.");
                        }
                        const item = cart.items.find(item => item.id === productId);
                        if (!item) {
                            throw new Error("Item não encontrado no carrinho.");
                        }
                        itemKey = item.key;
                        return fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=BR&shipping_address[province]=${province}`);
                    });
                }
            })
            .then(shippingResponse => shippingResponse.json())
            .then(shippingData => {
                if (shippingData.shipping_rates && shippingData.shipping_rates.length > 0) {
                    // Ordena as opções de frete pelo menor tempo de entrega
                    shippingData.shipping_rates.sort((a, b) => a.delivery_days[0] - b.delivery_days[0]);

                    var fastestShipping = shippingData.shipping_rates[0];
                    var otherShipping = shippingData.shipping_rates.slice(1);

                    var shippingOptions = `
                        <div class="shipping-option fastest">
                        <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M22.9456 5.96875L21.6331 2.6875C21.5218 2.40988 21.3296 2.17209 21.0816 2.00494C20.8335 1.83778 20.541 1.74897 20.2419 1.75H17V1C17 0.801088 16.921 0.610322 16.7803 0.46967C16.6397 0.329018 16.4489 0.25 16.25 0.25H2C1.60218 0.25 1.22064 0.408035 0.93934 0.68934C0.658035 0.970644 0.5 1.35218 0.5 1.75V12.25C0.5 12.6478 0.658035 13.0294 0.93934 13.3107C1.22064 13.592 1.60218 13.75 2 13.75H3.59375C3.75898 14.3953 4.13428 14.9673 4.66048 15.3757C5.18669 15.7842 5.83387 16.0059 6.5 16.0059C7.16613 16.0059 7.81331 15.7842 8.33952 15.3757C8.86573 14.9673 9.24102 14.3953 9.40625 13.75H14.0938C14.259 14.3953 14.6343 14.9673 15.1605 15.3757C15.6867 15.7842 16.3339 16.0059 17 16.0059C17.6661 16.0059 18.3133 15.7842 18.8395 15.3757C19.3657 14.9673 19.741 14.3953 19.9063 13.75H21.5C21.8978 13.75 22.2794 13.592 22.5607 13.3107C22.842 13.0294 23 12.6478 23 12.25V6.25C23.0003 6.15361 22.9818 6.0581 22.9456 5.96875ZM17 3.25H20.2419L21.1419 5.5H17V3.25ZM2 1.75H15.5V7.75H2V1.75ZM6.5 14.5C6.20333 14.5 5.91332 14.412 5.66665 14.2472C5.41997 14.0824 5.22771 13.8481 5.11418 13.574C5.00065 13.2999 4.97094 12.9983 5.02882 12.7074C5.0867 12.4164 5.22956 12.1491 5.43934 11.9393C5.64912 11.7296 5.91639 11.5867 6.20737 11.5288C6.49834 11.4709 6.79994 11.5006 7.07403 11.6142C7.34811 11.7277 7.58238 11.92 7.7472 12.1666C7.91203 12.4133 8 12.7033 8 13C8 13.3978 7.84197 13.7794 7.56066 14.0607C7.27936 14.342 6.89783 14.5 6.5 14.5ZM14.0938 12.25H9.40625C9.24102 11.6047 8.86573 11.0327 8.33952 10.6243C7.81331 10.2158 7.16613 9.99412 6.5 9.99412C5.83387 9.99412 5.18669 10.2158 4.66048 10.6243C4.13428 11.0327 3.75898 11.6047 3.59375 12.25H2V9.25H15.5V10.4041C15.1551 10.6034 14.8532 10.8692 14.6119 11.1861C14.3705 11.5029 14.1944 11.8646 14.0938 12.25ZM17 14.5C16.7033 14.5 16.4133 14.412 16.1666 14.2472C15.92 14.0824 15.7277 13.8481 15.6142 13.574C15.5007 13.2999 15.4709 12.9983 15.5288 12.7074C15.5867 12.4164 15.7296 12.1491 15.9393 11.9393C16.1491 11.7296 16.4164 11.5867 16.7074 11.5288C16.9983 11.4709 17.2999 11.5006 17.574 11.6142C17.8481 11.7277 18.0824 11.92 18.2472 12.1666C18.412 12.4133 18.5 12.7033 18.5 13C18.5 13.3978 18.342 13.7794 18.0607 14.0607C17.7794 14.342 17.3978 14.5 17 14.5ZM21.5 12.25H19.9063C19.739 11.6063 19.363 11.0362 18.8371 10.629C18.3112 10.2218 17.6651 10.0006 17 10V7H21.5V12.25Z" fill="#1A1919"/>
                          </svg>
                          
                            <div>
                              <b>${getDeliveryEstimate(fastestShipping.delivery_days)}</b>
                              ${
                                productPrice >= 100000
                                  ? "- Grátis"
                                  : (fastestShipping.price == "0.00" ? "Grátis" : "por R$ " + fastestShipping.price)
                              }
                            </div>
                        </div>
                        ${otherShipping.length > 0 ? `<span id="toggle-shipping">
                        

                        Mais formas de entrega <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.60156 5.89844L1.10156 1.39844C0.867188 1.1875 0.867188 0.835938 1.10156 0.601562C1.3125 0.390625 1.66406 0.390625 1.89844 0.601562L6 4.72656L10.1016 0.625C10.3125 0.390625 10.6641 0.390625 10.8984 0.625C11.1094 0.835938 11.1094 1.1875 10.8984 1.39844L6.375 5.89844C6.16406 6.13281 5.8125 6.13281 5.60156 5.89844Z" fill="#595856"/>
</svg>
</span>` : ''}
                        <div id="other-shipping" style="display: none;">
                        
                                
                            ${otherShipping.map(rate => `
                                <div class="shipping-option">
                                    <div><b>${rate.name}</b> ${rate.delivery_days ? getDeliveryEstimate(rate.delivery_days) : ''}</div>
                                    <div>${rate.price == "0.00" ? "Grátis" : "R$ " + rate.price}</div>
                                </div>
                            `).join('')}
                        </div>
                    `;

                    shippingResult.innerHTML = shippingOptions;

                    var location_store = document.getElementById('location_store');
                    location_store.style.display = 'flex';

                    // Adiciona evento para o botão de alternância
                    var toggleButton = document.getElementById('toggle-shipping');
                    if (toggleButton) {
                        toggleButton.addEventListener('click', function() {
                            var otherShippingDiv = document.getElementById('other-shipping');
                            if (otherShippingDiv.style.display === 'none') {
                                otherShippingDiv.style.display = 'block';
                            } else {
                                otherShippingDiv.style.display = 'none';
                            }
                        });
                    }
                } else {
                    shippingResult.innerHTML = "Nenhuma opção de frete disponível para este CEP.";
                }

                if (itemKey) {
                    return fetch(`/cart/change.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: itemKey, quantity: 0 })
                    });
                }
            })
            .then(() => console.log('Produto removido do carrinho após cálculo de frete.'))
            .catch(error => {
                shippingResult.innerHTML = "Erro ao obter opções de frete.";
                console.error('Erro:', error);
            });
    });
});

function formatZipCode(input) {
    let value = input.value.replace(/\D/g, '');
    if (value.length > 5) {
        value = value.slice(0, 5) + '-' + value.slice(5, 8);
    }
    input.value = value;
}
  } catch(e) { console.error(e); }
})();

})();
